import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData, masterdataindex } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import FitbitIcon from '@mui/icons-material/Fitbit';
import GamepadIcon from '@mui/icons-material/Gamepad';
import CopyrightIcon from '@mui/icons-material/Copyright';

function CustomerIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);  // Modal state        
    const history = useHistory();
    const { isAuthenticated, companyId, permissions, userId, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageEdit, setErrorMessageEdit] = useState("");

    // FOR Create new customer
    const [Name, setName] = useState('');
    const [AddressLine1, setAddressLine1] = useState('');
    const [AddressLine2, setAddressLine2] = useState('');
    const [ContactNumber1, setContactNumber1] = useState('');
    const [ContactNumber2, setContactNumber2] = useState('');
    const [GSTNumber, setGSTNumber] = useState('');
    const [PostalCode, setPostalCode] = useState('');
    const [OpeningBalance, setOpeningBalance] = useState('0');
    const [TransportationCharges, setTransportationCharges] = useState('0');
    const [IsPayableOrReceivable, setIsPayableOrReceivable] = useState(false);


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();

            return;
        }
        // Token is not expired, fetch data
        fetchtableData();
        setLoading(true);
    }, [isAuthenticated, companyId, userId, token, logout]);

    //Balance Sheet
    const [balancesheetOptions, setBalanceSheetOptions] = useState([]);
    const [selectedBalanceSheetType, setSelectedBalanceSheetType] = useState("");

    const fetchBalanceSheet = async () => {
        try {
            const response = await fetchData('BalanceSheetApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(balance => ({
                    value: balance.id,
                    label: balance.name
                }));
                setBalanceSheetOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleBalanceSheetChange = (selectedOption) => {
        setSelectedBalanceSheetType(selectedOption);
    };

    useEffect(() => {
        fetchBalanceSheet();
    }, []);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    //search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [isFocused, setIsFocused] = useState(false);
    const fetchtableData = async () => {
        setLoading(true);
        fetchData('CustomerApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);

                }
                console.log(response);
            })

            .catch((error) => {
                console.error('Error fetching CustomerApi:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    const handleDelete = async () => {
        deleteData('CustomerApi', `${deleteItemId}`, token)
            .then((response) => {
                setDeleteItemId(null);

                setConfirmDialogOpen(false);
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('CustomerApi', `${itemId}`)
            .then(() => {
                // Fetch table data or update state
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const addGroupRecord = async (e) => {
        e.preventDefault();
        setIsLoading(true); // show loader

        if (!Name) {
            setErrorMessage('Name is required !');
            setIsLoading(false);
            return;
        }

        // ✅ Check duplicate by comparing case-insensitive
        const isDuplicate = data.some(
            (item) => item.Name.trim().toLowerCase() === Name.trim().toLowerCase()
        );

        if (isDuplicate) {
            setErrorMessage("This Customer Name already exists!");
            setIsLoading(false);
            return;
        }

        const BalanceSheetHeadId = selectedBalanceSheetType.value;
        const Customer = {
            CompanyId: companyId,
            BalanceSheetHeadId,
            Name,
            AddressLine1,
            AddressLine2,
            ContactNumber1,
            ContactNumber2,
            GSTNumber,
            PostalCode,
            TransportationCharges,
            IsPayableOrReceivable,
            OpeningBalance,
            IsActive: true,
            CreatedBy: userId,
            CreatedDate: new Date(),
        };

        postData('CustomerApi', Customer, token)
            .then((response) => {
                console.log('Customer Created success:', response);
                setSuccessMessage("Customer Created successfully!");
                setErrorMessage("");
                setName("");
                setAddressLine1("");
                setAddressLine2("");
                setContactNumber1("");
                setContactNumber2("");
                setGSTNumber("");
                setPostalCode("");
                setOpeningBalance("0");
                setTransportationCharges("0");
                setIsPayableOrReceivable(false);

                setIsModalGrpOpen(false);
                window.location.reload();

                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Customer Create error:', error);
            })
            .finally(() => {
                setIsLoading(false); // hide loader
            });
    };

    //EDIT
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

    const openDetailModal = async (Id) => {
        try {
            const response = await fetchData('CustomerApi', `/MasterDetails/${Id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);

                // Set the balance sheet dropdown value
                if (response.response_data.BalanceSheetHeadId && response.response_data.BalanceSheetName) {
                    setSelectedBalanceSheetType({
                        value: response.response_data.BalanceSheetHeadId,
                        label: response.response_data.BalanceSheetName
                    });
                }

                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    };

    // master Group model
    const [isModalGrpOpen, setIsModalGrpOpen] = useState(false);
    const toggleModalGroup = () => {
        setIsModalGrpOpen(!isModalGrpOpen);
    };

    const toggleModalGrp2 = () => {
        setIsDetailModalOpen(false);
        setSelectedBalanceSheetType(null);
        setErrorMessageEdit('');
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };

    const [updatedData, setUpdateData] = useState({});

    const updateRecord = async (event) => {
        event.preventDefault();
        setIsUpdateLoading(true); // start loading

        if (!updatedData.Name) {
            setErrorMessageEdit('Name is required !');
            setIsUpdateLoading(false);
            return;
        }

        try {
            // Include BalanceSheetHeadId from the selected dropdown
            const dataToUpdate = {
                ...updatedData,
                BalanceSheetHeadId: selectedBalanceSheetType?.value || updatedData.BalanceSheetHeadId
            };

            await updateData('CustomerApi', `${updatedData.Id}`, dataToUpdate, token);

            setUpdateData({
                CompanyId: companyId,
                Name: '',
            });
            setSelectedBalanceSheetType(null);

            window.location.reload();
            setIsDetailModalOpen(false);
            fetchtableData();
        } catch (error) {
            console.error('Error updating record:', error);
        } finally {
            setIsUpdateLoading(false); // stop loading
        }
    };

    return (
        <div className="container mt-2 mx-auto" style={{ maxWidth: '97%' }}>
            <div className='mb-2 flex justify-between'>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>CUSTOMER</h6>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        backdropFilter: 'blur(4px)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <style>{`
                            .loader {
                                transform: rotateZ(45deg);
                                perspective: 1000px;
                                border-radius: 50%;
                                width: 48px;
                                height: 48px;
                                color: #fff;
                            }
                            .loader:before,
                            .loader:after {
                                content: '';
                                display: block;
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: inherit;
                                height: inherit;
                                border-radius: 50%;
                                transform: rotateX(70deg);
                                animation: 1s spin linear infinite;
                            }
                            .loader:after {
                                color: #FF3D00;
                                transform: rotateY(70deg);
                                animation-delay: .4s;
                            }
                            @keyframes spin {
                                0%, 100% {
                                    box-shadow: .2em 0px 0 0px currentcolor;
                                }
                                12% {
                                    box-shadow: .2em .2em 0 0 currentcolor;
                                }
                                25% {
                                    box-shadow: 0 .2em 0 0px currentcolor;
                                }
                                37% {
                                    box-shadow: -.2em .2em 0 0 currentcolor;
                                }
                                50% {
                                    box-shadow: -.2em 0 0 0 currentcolor;
                                }
                                62% {
                                    box-shadow: -.2em -.2em 0 0 currentcolor;
                                }
                                75% {
                                    box-shadow: 0px -.2em 0 0 currentcolor;
                                }
                                87% {
                                    box-shadow: .2em -.2em 0 0 currentcolor;
                                }
                            }
                        `}</style>
                        <div className="loader"></div>
                        <span style={{ color: 'white', marginTop: '30px', fontSize: '16px', fontWeight: '500', letterSpacing: '0.5px' }}>
                            Loading...
                        </span>
                    </div>
                )}

                <div style={{ marginLeft: '-30px', marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '270px' : '200px',
                            height: '30px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        }}
                    />
                </div>

                <Tooltip
                    title="Customer Registration" arrow
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: 'White',
                                color: 'black',
                                border: '1px solid white',
                                fontWeight: 'bold',
                                boxShadow: 2,
                            },
                        },
                    }}
                >
                    <Button
                        style={{ background: 'linear-gradient(to right, #041815ff, #045157ff)', marginLeft: '8px', color: 'white', fontWeight: 'bolder', height: '30px', fontSize: '11px', textTransform: 'uppercase', marginTop: '-2px', borderRadius: '25px' }}
                        onClick={toggleModalGroup}
                        className="linkcolor"
                    >
                        ADD CUSTOMER
                    </Button>
                </Tooltip>
            </div>

            {isModalGrpOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}>
                    <div
                        className="bg-white w-full overflow-hidden"
                        style={{
                            maxWidth: '900px',
                            maxHeight: '70vh',
                            borderRadius: '16px',
                            boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.25)',
                            animation: 'zoomIn 0.3s ease-out'
                        }}
                    >
                        {/* Modal Header */}
                        <div style={{
                            // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            background: 'linear-gradient(135deg, #041815ff 0%, #045157ff 100%)',
                            padding: '16px 24px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
                        }}>
                            <div style={{ height: '20px' }}>
                                <h6 style={{
                                    color: 'white',
                                    fontSize: '15px',
                                    fontWeight: '700',
                                    margin: 0,
                                    letterSpacing: '-0.3px'
                                }}>
                                    New Customer
                                </h6>
                                <p style={{
                                    color: 'rgba(255, 255, 255, 0.9)',
                                    fontSize: '13px',
                                    margin: '2px 0 0 0'
                                }}>
                                    Add a new customer to your system
                                </p>
                            </div>
                            <button
                                onClick={toggleModalGroup}
                                style={{
                                    background: 'rgba(255, 255, 255, 0.2)',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '36px',
                                    height: '36px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    color: 'white',
                                    fontSize: '22px',
                                    fontWeight: '300'
                                }}
                                onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
                                onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
                            >
                                ×
                            </button>
                        </div>

                        {/* Modal Body */}
                        <div className="overflow-y-auto" style={{ maxHeight: 'calc(85vh - 150px)', padding: '16px 20px' }}>

                            {errorMessage && (
                                <div style={{
                                    background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
                                    border: '1px solid #fca5a5',
                                    borderRadius: '12px',
                                    padding: '16px',
                                    marginBottom: '24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px'
                                }}>
                                    <span style={{ fontSize: '20px' }}>⚠️</span>
                                    <p style={{ color: '#991b1b', fontSize: '14px', margin: 0, fontWeight: '500' }}>{errorMessage}</p>
                                </div>
                            )}

                            <form onSubmit={addGroupRecord}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                    {/* Section 1: Basic Information */}
                                    <div>
                                        <h5 style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#374151',
                                            marginBottom: '12px',
                                            paddingBottom: '6px',
                                            borderBottom: '2px solid #e5e7eb'
                                        }}>
                                            Basic Information
                                        </h5>
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                            <div className="md:col-span-1">
                                                <label style={{
                                                    display: 'block',
                                                    color: '#374151',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    marginBottom: '6px'
                                                }}>
                                                    Balance Sheet <span style={{ color: '#ef4444' }}>*</span>
                                                </label>
                                                <Select
                                                    value={selectedBalanceSheetType}
                                                    onChange={handleBalanceSheetChange}
                                                    options={balancesheetOptions}
                                                    placeholder="Select balance sheet"
                                                    isSearchable
                                                    styles={{
                                                        control: (base, state) => ({
                                                            ...base,
                                                            borderRadius: '10px',
                                                            borderColor: state.isFocused ? '#667eea' : '#e5e7eb',
                                                            boxShadow: state.isFocused ? '0 0 0 2px rgba(102, 126, 234, 0.1)' : 'none',
                                                            '&:hover': { borderColor: '#667eea' },
                                                            minHeight: '32px',
                                                            height: '32px',
                                                            fontSize: '12.5px',
                                                        }),
                                                        menu: (base) => ({
                                                            ...base,
                                                            fontSize: '12px',
                                                        }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            fontSize: '12px',
                                                            padding: '6px 10px',
                                                        }),
                                                        singleValue: (base) => ({
                                                            ...base,
                                                            fontSize: '12px',
                                                        }),
                                                    }}
                                                />

                                            </div>
                                            <div className="md:col-span-2">
                                                <label style={{
                                                    display: 'block',
                                                    color: '#374151',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    marginBottom: '6px'
                                                }}>
                                                    Customer Name <span style={{ color: '#ef4444' }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={Name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '7px 10px',
                                                        border: '2px solid #e5e7eb',
                                                        borderRadius: '8px',
                                                        fontSize: '13px',
                                                        transition: 'all 0.2s ease',
                                                        outline: 'none',
                                                        height: '32px'
                                                    }}
                                                    placeholder="Enter customer name"
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor = '#667eea';
                                                        e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor = '#e5e7eb';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Section 2: Address Information */}
                                    <div>
                                        {/* <h5 style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#374151',
                                            marginBottom: '12px',
                                            paddingBottom: '6px',
                                            borderBottom: '2px solid #e5e7eb'
                                        }}>
                                            Address Details
                                        </h5> */}
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                            {[
                                                { label: 'Address Line 1', value: AddressLine1, setter: setAddressLine1, placeholder: 'Street address' },
                                                { label: 'Address Line 2', value: AddressLine2, setter: setAddressLine2, placeholder: 'Apartment, suite, etc.' }
                                            ].map((field, index) => (
                                                <div key={index}>
                                                    <label style={{
                                                        display: 'block',
                                                        color: '#374151',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        marginBottom: '6px'
                                                    }}>{field.label}</label>
                                                    <input
                                                        type="text"
                                                        value={field.value}
                                                        onChange={(e) => field.setter(e.target.value)}
                                                        style={{
                                                            width: '100%',
                                                            padding: '9px 12px',
                                                            border: '2px solid #e5e7eb',
                                                            borderRadius: '10px',
                                                            fontSize: '13px',
                                                            transition: 'all 0.2s ease',
                                                            outline: 'none',
                                                            height: '32px'
                                                        }}
                                                        placeholder={field.placeholder}
                                                        onFocus={(e) => {
                                                            e.target.style.borderColor = '#667eea';
                                                            e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
                                                        }}
                                                        onBlur={(e) => {
                                                            e.target.style.borderColor = '#e5e7eb';
                                                            e.target.style.boxShadow = 'none';
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Section 3: Contact & Tax Information */}
                                    <div>
                                        {/* <h5 style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#374151',
                                            marginBottom: '12px',
                                            paddingBottom: '6px',
                                            borderBottom: '2px solid #e5e7eb'
                                        }}>
                                            Contact & Tax Information
                                        </h5> */}
                                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                                            {[
                                                { label: 'Contact Number 1', value: ContactNumber1, setter: setContactNumber1, placeholder: '+91 XXXXX XXXXX' },
                                                { label: 'Contact Number 2', value: ContactNumber2, setter: setContactNumber2, placeholder: '+91 XXXXX XXXXX' },
                                                { label: 'GST Number', value: GSTNumber, setter: setGSTNumber, placeholder: 'GST Number' },
                                                { label: 'Postal Code', value: PostalCode, setter: setPostalCode, placeholder: 'Postal Code' }
                                            ].map((field, index) => (
                                                <div key={index}>
                                                    <label style={{
                                                        display: 'block',
                                                        color: '#374151',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        marginBottom: '6px'
                                                    }}>{field.label}</label>
                                                    <input
                                                        type="text"
                                                        value={field.value}
                                                        onChange={(e) => field.setter(e.target.value)}
                                                        style={{
                                                            width: '100%',
                                                            padding: '9px 12px',
                                                            border: '2px solid #e5e7eb',
                                                            borderRadius: '10px',
                                                            fontSize: '13px',
                                                            transition: 'all 0.2s ease',
                                                            outline: 'none',
                                                            height: '32px'
                                                        }}
                                                        placeholder={field.placeholder}
                                                        onFocus={(e) => {
                                                            e.target.style.borderColor = '#667eea';
                                                            e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
                                                        }}
                                                        onBlur={(e) => {
                                                            e.target.style.borderColor = '#e5e7eb';
                                                            e.target.style.boxShadow = 'none';
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Section 4: Financial Information */}
                                    <div>
                                        <h5 style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#374151',
                                            marginBottom: '12px',
                                            paddingBottom: '6px',
                                            borderBottom: '2px solid #e5e7eb'
                                        }}>
                                            Financial Information
                                        </h5>
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                            <div>
                                                <label style={{
                                                    display: 'block',
                                                    color: '#374151',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    marginBottom: '6px'
                                                }}>
                                                    Transportation fee
                                                </label>
                                                <input
                                                    type="number"
                                                    value={TransportationCharges}
                                                    onChange={(e) => setTransportationCharges(e.target.value)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '9px 12px',
                                                        border: '2px solid #e5e7eb',
                                                        borderRadius: '10px',
                                                        fontSize: '13px',
                                                        transition: 'all 0.2s ease',
                                                        outline: 'none',
                                                        height: '29px',
                                                        textAlign: 'right'
                                                    }}
                                                    placeholder="0.00"
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor = '#667eea';
                                                        e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor = '#e5e7eb';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <label style={{
                                                    display: 'block',
                                                    color: '#374151',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    marginBottom: '6px'
                                                }}>
                                                    Opening Balance
                                                </label>
                                                <input
                                                    type="number"
                                                    value={OpeningBalance}
                                                    onChange={(e) => setOpeningBalance(e.target.value)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '9px 12px',
                                                        border: '2px solid #e5e7eb',
                                                        borderRadius: '10px',
                                                        fontSize: '13px',
                                                        transition: 'all 0.2s ease',
                                                        outline: 'none',
                                                        height: '29px',
                                                        textAlign: 'right'
                                                    }}
                                                    placeholder="0.00"
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor = '#667eea';
                                                        e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor = '#e5e7eb';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                />
                                            </div>

                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '12px',
                                                padding: '16px',
                                                background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
                                                borderRadius: '12px',
                                                marginTop: '24px',
                                                height: '29px'
                                            }}>
                                                <input
                                                    type="checkbox"
                                                    checked={IsPayableOrReceivable}
                                                    onChange={(e) => setIsPayableOrReceivable(e.target.checked)}
                                                    id="isPayableOrReceivable"
                                                    style={{
                                                        width: '20px',
                                                        height: '20px',
                                                        cursor: 'pointer',
                                                        accentColor: '#667eea'
                                                    }}
                                                />
                                                <label
                                                    htmlFor="isPayableOrReceivable"
                                                    style={{
                                                        color: '#374151',
                                                        fontSize: '14px',
                                                        fontWeight: '600',
                                                        cursor: 'pointer',
                                                        userSelect: 'none',
                                                    }}
                                                >
                                                    Is Payable / Receivable
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>

                        {/* Modal Footer */}
                        <div style={{
                            background: 'linear-gradient(to right, #f9fafb, #f3f4f6)',
                            padding: '16px 24px',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: '12px',
                            borderTop: '1px solid #e5e7eb'
                        }}>
                            <button
                                onClick={toggleModalGroup}
                                disabled={isLoading}
                                style={{
                                    padding: '8px 24px',
                                    background: 'white',
                                    border: '2px solid #e5e7eb',
                                    borderRadius: '10px',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    color: '#6b7280',
                                    cursor: isLoading ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.2s ease',
                                    opacity: isLoading ? 0.5 : 1
                                }}
                                onMouseEnter={(e) => !isLoading && (e.target.style.background = '#f9fafb')}
                                onMouseLeave={(e) => !isLoading && (e.target.style.background = 'white')}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={addGroupRecord}
                                disabled={isLoading}
                                style={{
                                    padding: '8px 24px',
                                    //background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    background: 'linear-gradient(135deg, #041815ff 0%, #045157ff 100%)',
                                    border: 'none',
                                    borderRadius: '10px',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    color: 'white',
                                    cursor: isLoading ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.2s ease',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                                    opacity: isLoading ? 0.7 : 1
                                }}
                                onMouseEnter={(e) => !isLoading && (e.target.style.transform = 'translateY(-2px)')}
                                onMouseLeave={(e) => !isLoading && (e.target.style.transform = 'translateY(0)')}
                            >
                                {isLoading ? (
                                    <>
                                        <CircularProgress size={18} color="inherit" />
                                        <span>Saving...</span>
                                    </>
                                ) : (
                                    <>
                                        <span>✓</span>
                                        <span>Add Customer</span>
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )
            }

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', width: '100%' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#134B70', padding: '2px' }}>

                            <TableRow>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #051a20ff, #051a20ff)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    Sl.No
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #051a20ff, #051a20ff)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    Name
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #051a20ff, #051a20ff)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    Contact No 1
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #051a20ff, #051a20ff)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    Contact No 2
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #051a20ff, #051a20ff)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    GST No
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #051a20ff, #051a20ff)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    Postal Code
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #051a20ff, #051a20ff)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredData && filteredData.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    sx={{
                                        '&:hover': { backgroundColor: '#F1E7E7' },
                                        transition: 'background-color 0.3s ease-in-out',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <TableCell sx={{ padding: '2px', borderRight: '1px solid # #f4dfdfff', fontSize: '11.5px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ padding: '2px', width: '30%', borderRight: '1px solid # #f4dfdfff', fontSize: '11.5px' }}>{item.Name}</TableCell>
                                    <TableCell sx={{ padding: '2px', textAlign: 'left', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px', fontSize: '11.5px' }}>{item.ContactNumber1}</TableCell>
                                    <TableCell sx={{ padding: '2px', textAlign: 'left', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>{item.ContactNumber2}</TableCell>
                                    <TableCell sx={{ padding: '2px', textAlign: 'left', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>{item.GSTNumber}</TableCell>
                                    <TableCell sx={{ padding: '2px', textAlign: 'left', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>{item.PostalCode}</TableCell>
                                    <TableCell sx={{ padding: '2px', textAlign: 'right', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>
                                        {/* {hasEditMasterPermission && ( */}
                                        <Tooltip
                                            title="Customer Edit" arrow
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#110441ff',
                                                        color: 'white',
                                                        border: '1px solid white',
                                                        fontWeight: 'bold',
                                                        boxShadow: 2,
                                                    },
                                                },
                                            }}
                                        >
                                            <IconButton onClick={() => openDetailModal(item.Id)}>
                                                <EditIcon style={{ color: '#110441ff', fontSize: '17px' }} />
                                            </IconButton>
                                        </Tooltip>
                                        {/* )}
                                        {hasDeleteMasterPermission && ( */}
                                        <Tooltip
                                            title="Customer Delete" arrow
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#DA6C6C',
                                                        color: 'white',
                                                        border: '1px solid white',
                                                        fontWeight: 'bold',
                                                        boxShadow: 2,
                                                    },
                                                },
                                            }}
                                        >
                                            <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))}>
                                                {item.IsActive ? <DeleteIcon style={{ color: 'brown', fontSize: '17px' }} /> : <ActivateIcon />}
                                            </IconButton>
                                        </Tooltip>
                                        {/* )} */}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button onClick={closeConfirmDialog} className="bg-red-600 text-white border border-red-600 rounded px-4 py-2 mr-2">
                                    Cancel
                                </button>
                                <button onClick={handleDelete} className="bg-green-600 text-white border border-green-600 rounded px-4 py-2">
                                    Confirm
                                </button>
                            </DialogActions>
                        </Dialog>

                    </Table>
                </TableContainer>

                {isDetailModalOpen && (
                    <div className="fixed inset-0 flex items-center justify-center z-50 p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}>
                        <div
                            className="bg-white w-full overflow-hidden"
                            style={{
                                maxWidth: '900px',
                                maxHeight: '70vh',
                                borderRadius: '16px',
                                boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.25)',
                                animation: 'zoomIn 0.3s ease-out'
                            }}
                        >
                            {/* Modal Header */}
                            <div style={{
                                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                padding: '16px 24px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
                            }}>
                                <div style={{ height: '20px' }}>
                                    <h6 style={{
                                        color: 'white',
                                        fontSize: '15px',
                                        fontWeight: '700',
                                        margin: 0,
                                        letterSpacing: '-0.3px'
                                    }}>
                                        Edit Customer
                                    </h6>
                                    <p style={{
                                        color: 'rgba(255, 255, 255, 0.9)',
                                        fontSize: '13px',
                                        margin: '2px 0 0 0'
                                    }}>
                                        Update customer information
                                    </p>
                                </div>
                                <button
                                    onClick={toggleModalGrp2}
                                    style={{
                                        background: 'rgba(255, 255, 255, 0.2)',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '36px',
                                        height: '36px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        color: 'white',
                                        fontSize: '22px',
                                        fontWeight: '300'
                                    }}
                                    onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
                                    onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
                                >
                                    ×
                                </button>
                            </div>

                            {/* Modal Body */}
                            <div className="overflow-y-auto" style={{ maxHeight: 'calc(75vh - 150px)', padding: '16px 20px' }}>
                                {errorMessageEdit && (
                                    <div style={{
                                        background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
                                        border: '1px solid #fca5a5',
                                        borderRadius: '12px',
                                        padding: '16px',
                                        marginBottom: '24px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px'
                                    }}>
                                        <span style={{ fontSize: '20px' }}>⚠️</span>
                                        <p style={{ color: '#991b1b', fontSize: '14px', margin: 0, fontWeight: '500' }}>{errorMessageEdit}</p>
                                    </div>
                                )}

                                <form onSubmit={updateRecord}>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                        {/* Section 1: Basic Information */}
                                        <h3 style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#374151',
                                            marginBottom: '12px',
                                            paddingBottom: '6px',
                                            borderBottom: '2px solid #e5e7eb'
                                        }}>
                                            Basic Information
                                        </h3>
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                            <div className="md:col-span-1">
                                                <label style={{
                                                    display: 'block',
                                                    color: '#374151',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    marginBottom: '6px'
                                                }}>
                                                    Balance Sheet <span style={{ color: '#ef4444' }}>*</span>
                                                </label>
                                                <Select
                                                    value={selectedBalanceSheetType}
                                                    onChange={handleBalanceSheetChange}
                                                    options={balancesheetOptions}
                                                    placeholder="Select balance sheet"
                                                    isSearchable
                                                    styles={{
                                                        control: (base, state) => ({
                                                            ...base,
                                                            borderRadius: '10px',
                                                            borderColor: state.isFocused ? '#f59e0b' : '#e5e7eb',
                                                            boxShadow: state.isFocused ? '0 0 0 2px rgba(245, 158, 11, 0.1)' : 'none',
                                                            '&:hover': { borderColor: '#f59e0b' },
                                                            minHeight: '32px',
                                                            height: '32px',
                                                            fontSize: '12.5px',
                                                        }),
                                                        menu: (base) => ({
                                                            ...base,
                                                            fontSize: '12px',
                                                        }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            fontSize: '11.5px',
                                                            padding: '6px 10px',
                                                        }),
                                                        singleValue: (base) => ({
                                                            ...base,
                                                            fontSize: '12px',
                                                        }),
                                                    }}
                                                />

                                            </div>
                                            <div className="md:col-span-2">
                                                <label style={{
                                                    display: 'block',
                                                    color: '#374151',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    marginBottom: '6px'
                                                }}>
                                                    Customer Name <span style={{ color: '#ef4444' }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="Name"
                                                    value={updatedData.Name || ''}
                                                    onChange={handleUpdateInputChange}
                                                    style={{
                                                        width: '100%',
                                                        padding: '7px 10px',
                                                        border: '2px solid #e5e7eb',
                                                        borderRadius: '8px',
                                                        fontSize: '13px',
                                                        transition: 'all 0.2s ease',
                                                        outline: 'none',
                                                        height: '32px'
                                                    }}
                                                    placeholder="Enter customer name"
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor = '#667eea';
                                                        e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor = '#e5e7eb';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Section 2: Address Information */}
                                        <div>
                                            {/* <h5 style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#374151',
                                            marginBottom: '12px',
                                            paddingBottom: '6px',
                                            borderBottom: '2px solid #e5e7eb'
                                        }}>
                                            Address Details
                                        </h5> */}
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                                {[
                                                    { label: 'Address Line 1', name: 'AddressLine1', placeholder: 'Street address' },
                                                    { label: 'Address Line 2', name: 'AddressLine2', placeholder: 'Apartment, suite, etc.' }
                                                ].map((field, index) => (
                                                    <div key={index}>
                                                        <label style={{
                                                            display: 'block',
                                                            color: '#374151',
                                                            fontSize: '12px',
                                                            fontWeight: '600',
                                                            marginBottom: '6px'
                                                        }}>{field.label}</label>
                                                        <input
                                                            type="text"
                                                            name={field.name}
                                                            value={updatedData[field.name] || ''}
                                                            onChange={handleUpdateInputChange}
                                                            style={{
                                                                width: '100%',
                                                                padding: '9px 12px',
                                                                border: '2px solid #e5e7eb',
                                                                borderRadius: '10px',
                                                                fontSize: '13px',
                                                                transition: 'all 0.2s ease',
                                                                outline: 'none',
                                                                height: '32px'
                                                            }}
                                                            placeholder={field.placeholder}
                                                            onFocus={(e) => {
                                                                e.target.style.borderColor = '#f59e0b';
                                                                e.target.style.boxShadow = '0 0 0 2px rgba(245, 158, 11, 0.1)';
                                                            }}
                                                            onBlur={(e) => {
                                                                e.target.style.borderColor = '#e5e7eb';
                                                                e.target.style.boxShadow = 'none';
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Section 3: Contact & Tax Information */}
                                        <div>
                                            {/* <h5 style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#374151',
                                            marginBottom: '12px',
                                            paddingBottom: '6px',
                                            borderBottom: '2px solid #e5e7eb'
                                        }}>
                                            Contact & Tax Information
                                        </h5> */}
                                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                                                {[
                                                    { label: 'Contact Number 1', name: 'ContactNumber1', placeholder: '+91 XXXXX XXXXX' },
                                                    { label: 'Contact Number 2', name: 'ContactNumber2', placeholder: '+91 XXXXX XXXXX' },
                                                    { label: 'GST Number', name: 'GSTNumber', placeholder: 'GST Number' },
                                                    { label: 'Postal Code', name: 'PostalCode', placeholder: 'Postal Code' }
                                                ].map((field, index) => (
                                                    <div key={index}>
                                                        <label style={{
                                                            display: 'block',
                                                            color: '#374151',
                                                            fontSize: '12px',
                                                            fontWeight: '600',
                                                            marginBottom: '6px'
                                                        }}>{field.label}</label>
                                                        <input
                                                            type="text"
                                                            name={field.name}
                                                            value={updatedData[field.name] || ''}
                                                            onChange={handleUpdateInputChange}
                                                            style={{
                                                                width: '100%',
                                                                padding: '9px 12px',
                                                                border: '2px solid #e5e7eb',
                                                                borderRadius: '10px',
                                                                fontSize: '13px',
                                                                transition: 'all 0.2s ease',
                                                                outline: 'none',
                                                                height: '32px'
                                                            }}
                                                            placeholder={field.placeholder}
                                                            onFocus={(e) => {
                                                                e.target.style.borderColor = '#f59e0b';
                                                                e.target.style.boxShadow = '0 0 0 2px rgba(245, 158, 11, 0.1)';
                                                            }}
                                                            onBlur={(e) => {
                                                                e.target.style.borderColor = '#e5e7eb';
                                                                e.target.style.boxShadow = 'none';
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Section 4: Financial Information */}
                                        <div>
                                            <h5 style={{
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                marginBottom: '12px',
                                                paddingBottom: '6px',
                                                borderBottom: '2px solid #e5e7eb'
                                            }}>
                                                Financial Information
                                            </h5>
                                            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                                <div>
                                                    <label style={{
                                                        display: 'block',
                                                        color: '#374151',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        marginBottom: '6px'
                                                    }}>
                                                        Transportation Fee
                                                    </label>
                                                    <input
                                                        type="number"
                                                        name="TransportationCharges"
                                                        value={updatedData.TransportationCharges || '0'}
                                                        onChange={handleUpdateInputChange}
                                                        style={{
                                                            width: '100%',
                                                            padding: '9px 12px',
                                                            border: '2px solid #e5e7eb',
                                                            borderRadius: '10px',
                                                            fontSize: '13px',
                                                            transition: 'all 0.2s ease',
                                                            outline: 'none',
                                                            height: '29px',
                                                            textAlign: 'right'
                                                        }}
                                                        placeholder="0.00"
                                                        onFocus={(e) => {
                                                            e.target.style.borderColor = '#f59e0b';
                                                            e.target.style.boxShadow = '0 0 0 2px rgba(245, 158, 11, 0.1)';
                                                        }}
                                                        onBlur={(e) => {
                                                            e.target.style.borderColor = '#e5e7eb';
                                                            e.target.style.boxShadow = 'none';
                                                        }}
                                                    />
                                                </div>

                                                <div>
                                                    <label style={{
                                                        display: 'block',
                                                        color: '#374151',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        marginBottom: '6px'
                                                    }}>
                                                        Opening Balance
                                                    </label>
                                                    <input
                                                        type="number"
                                                        name="OpeningBalance"
                                                        value={updatedData.OpeningBalance || '0'}
                                                        onChange={handleUpdateInputChange}
                                                        style={{
                                                            width: '100%',
                                                            padding: '9px 12px',
                                                            border: '2px solid #e5e7eb',
                                                            borderRadius: '10px',
                                                            fontSize: '13px',
                                                            transition: 'all 0.2s ease',
                                                            outline: 'none',
                                                            height: '29px',
                                                            textAlign: 'right'
                                                        }}
                                                        placeholder="0.00"
                                                        onFocus={(e) => {
                                                            e.target.style.borderColor = '#f59e0b';
                                                            e.target.style.boxShadow = '0 0 0 2px rgba(245, 158, 11, 0.1)';
                                                        }}
                                                        onBlur={(e) => {
                                                            e.target.style.borderColor = '#e5e7eb';
                                                            e.target.style.boxShadow = 'none';
                                                        }}
                                                    />
                                                </div>

                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '12px',
                                                    padding: '16px',
                                                    background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
                                                    borderRadius: '12px',
                                                    marginTop: '24px',
                                                    height: '29px'
                                                }}>
                                                    <input
                                                        type="checkbox"
                                                        name="IsPayableOrReceivable"
                                                        checked={updatedData.IsPayableOrReceivable || false}
                                                        onChange={(e) =>
                                                            handleUpdateInputChange({
                                                                target: {
                                                                    name: "IsPayableOrReceivable",
                                                                    value: e.target.checked,
                                                                },
                                                            })
                                                        }
                                                        id="isPayableOrReceivableEdit"
                                                        style={{
                                                            width: '20px',
                                                            height: '20px',
                                                            cursor: 'pointer',
                                                            accentColor: '#f59e0b'
                                                        }}
                                                    />
                                                    <label
                                                        htmlFor="isPayableOrReceivableEdit"
                                                        style={{
                                                            color: '#78350f',
                                                            fontSize: '14px',
                                                            fontWeight: '600',
                                                            cursor: 'pointer',
                                                            userSelect: 'none'
                                                        }}
                                                    >
                                                        Is Payable / Receivable
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            {/* Modal Footer */}
                            <div style={{
                                background: 'linear-gradient(to right, #f9fafb, #f3f4f6)',
                                padding: '16px 24px',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: '12px',
                                borderTop: '1px solid #e5e7eb'
                            }}>
                                <button
                                    onClick={toggleModalGrp2}
                                    disabled={isUpdateLoading}
                                    style={{
                                        padding: '8px 24px',
                                        background: 'white',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '10px',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        color: '#6b7280',
                                        cursor: isUpdateLoading ? 'not-allowed' : 'pointer',
                                        transition: 'all 0.2s ease',
                                        opacity: isUpdateLoading ? 0.5 : 1
                                    }}
                                    onMouseEnter={(e) => !isUpdateLoading && (e.target.style.background = '#f9fafb')}
                                    onMouseLeave={(e) => !isUpdateLoading && (e.target.style.background = 'white')}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={updateRecord}
                                    disabled={isUpdateLoading}
                                    style={{
                                        padding: '8px 24px',
                                        background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                        border: 'none',
                                        borderRadius: '10px',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        color: 'white',
                                        cursor: isUpdateLoading ? 'not-allowed' : 'pointer',
                                        transition: 'all 0.2s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        boxShadow: '0 4px 12px rgba(245, 158, 11, 0.3)',
                                        opacity: isUpdateLoading ? 0.7 : 1
                                    }}
                                    onMouseEnter={(e) => !isUpdateLoading && (e.target.style.transform = 'translateY(-2px)')}
                                    onMouseLeave={(e) => !isUpdateLoading && (e.target.style.transform = 'translateY(0)')}
                                >
                                    {isUpdateLoading ? (
                                        <>
                                            <CircularProgress size={18} color="inherit" />
                                            <span>Updating...</span>
                                        </>
                                    ) : (
                                        <>
                                            <span>✓</span>
                                            <span>Update Customer</span>
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                )
                }

                <div style={{
                    position: 'fixed',
                    bottom: '12px',
                    right: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.3rem',
                    padding: '0.3rem 0.65rem',
                    background: 'rgba(255, 255, 255, 0.9)',
                    borderRadius: '14px',
                    boxShadow: '0 1px 6px rgba(0, 0, 0, 0.06)',
                    fontFamily: 'serif',
                    fontWeight: 'bold',
                    color: '#2c3e50',
                    fontSize: '0.7rem',
                    backdropFilter: 'blur(10px)'
                }}>
                    <CopyrightIcon />
                    <b>EFFTABS SOLUTIONS LLP</b>
                </div>
            </div >
        </div >
    );
}

export default CustomerIndex;
